import { Box, Typography } from "@mui/material";

export default function Vehicles() {
  return (
    <Box p={3}>
      <Typography variant="h4">Vehicles Management</Typography>
    </Box>
  );
}